import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_14.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from 'next/router';
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter14.json";


export default function Chapter_14() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
      <Head>
        <title>The divinity of numbers | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content=" Divine Infinite Being, Central Doctrine, Chapter-XIV"
        ></meta>
        <meta
          property="og:title"
          content="The divinity of numbers | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter14_OG_image_14_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Graphic representation of the divine significance of numbers, featuring sacred geometrical patterns and cosmic symbolism."></meta>
        <meta
          property="og:description"
          content="Platonism was a combination of the discourses of Socrates and the mystical mathematics of the Pythagorean sect."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=14"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter14_OG_image_14_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Graphic representation of the divine significance of numbers, featuring sacred geometrical patterns and cosmic symbolism."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=14"></meta>
        <meta name="twitter:title" content="The divinity of numbers | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Platonism was a combination of the discourses of Socrates and the mystical mathematics of the Pythagorean sect."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=14" />
      </Head>

      <Common_html BlockData={BlockData} />

     
    </>
  );
}
